/**
 * Client-only UI state: a page asking the app shell to open ITS profile dialog
 * with the Contact Methods add input focused (#1400, Q-353).
 *
 * The shell owns the one `ProfileEditDialog`; a page (the dashboard's empty
 * To Do) cannot render a second instance, so it raises this request. The shell
 * opens the dialog, and the contact-methods editor consumes the request once
 * it has focused its add input.
 */
import { create } from 'zustand';
import { registerStoreReset } from './registry';

export interface ProfileDialogState {
  /** A page asked for the profile dialog with the add input focused. */
  addMethodRequested: boolean;
  requestAddMethod: () => void;
  clearAddMethodRequest: () => void;
}

export const useProfileDialogStore = create<ProfileDialogState>((set) => ({
  addMethodRequested: false,
  requestAddMethod: () => set({ addMethodRequested: true }),
  clearAddMethodRequest: () => set({ addMethodRequested: false }),
}));

registerStoreReset(() => useProfileDialogStore.setState({ addMethodRequested: false }), {
  onUserSwitch: false, // an open request / dialog stays through a switch (#1336)
});
